<template>
    <div class="tag-box">
        <div class="tag-list">
            <div class="tag-list-header">标签列表</div>
            <div class="tag-list-content">
                <el-tree
                        :props="defaultProps"
                        :data="tagsList"
                        show-checkbox
                        node-key="id"
                        ref="tree"
                        @check-change="handleCheckChange"

                >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>
                             <i class="arsenal_icon arsenalfolder-open-fill"  v-if="data.tags"></i>
                            <i class="arsenal_icon arsenaldabiaoqian" v-else></i>
                        </span>
                         <span>{{ node.label }}</span>
                     </span>
                </el-tree>
            </div>
        </div>
        <div class="tag-selected">
            <div class="tag-selected-header">已选择标签</div>
            <div v-for="(tag,index) in tags" :key="index" class="checkTags">
                <div class="tagName">
                    <i class="arsenal_icon arsenaldabiaoqian"></i>
                    {{tag.name}}
                </div>
                <i class="el-icon-close" @click="deleteTag(tag.id)"></i>
            </div>
            <div class="tag-selected-content">
            </div>
        </div>
    </div>
</template>

<script>
    import {formatTree} from "./utils/formatTree";

    export default {
        data() {
            return {
                defaultProps: {
                    label: "name",
                    children: "tags",
                },
                tagsList: [],
                tags: [],
            };
        },
        methods: {
            handleCheckChange(data, checked, indeterminate) {
                console.log(this.$refs.tree.getCheckedKeys())
                console.log(this.tagsList)
                let ids = []
                let values = this.$refs.tree.getCheckedKeys()
                for (let j = 0; j < values.length; j++) {
                    for (let i = 0; i < this.tagsList.length; i++) {
                        this.tagsList[i].tags.forEach(tag => {
                            if (tag.id === values[j]) {
                                ids.push(tag)
                            }
                        })
                    }
                }
                console.log(ids)
                this.tags = ids

            },
            handleNodeClick(data) {
                console.log(data);
            },
            loadTagsData() {
                this.$http.get("/scrm-api/client-tag/group").then((response) => {
                    console.log('tags list:', response.data);
                    this.tagsList = formatTree(JSON.parse(JSON.stringify(response.data)));
                });
            },
            loadNode(node, resolve) {
                if (node.level === 0) {
                    return resolve([{name: "region1"}, {name: "region2"}]);
                }
                if (node.level > 3) return resolve([]);

                var hasChild;
                if (node.data.name === "region1") {
                    hasChild = true;
                } else if (node.data.name === "region2") {
                    hasChild = false;
                } else {
                    hasChild = Math.random() > 0.5;
                }

                setTimeout(() => {
                    var data;
                    if (hasChild) {
                        data = [
                            {
                                name: "zone" + this.count++,
                            },
                            {
                                name: "zone" + this.count++,
                            },
                        ];
                    } else {
                        data = [];

                    }

                    resolve(data);
                }, 500);
            },
            deleteTag(id) {
                console.log(id)
                console.log(this.$refs.tree.getCheckedKeys())
                for (let i = 0; i < this.tags.length; i++) {
                    if (this.tags[i].id === id) {
                        this.tags.splice(i, 1)
                    }
                }
                let ids = []
                console.log(this.tags)
                for (let i = 0; i < this.tags.length; i++) {
                    ids.push(this.tags[i].id)
                }
                console.log('ids', ids)
                this.$nextTick(() => {
                    this.$refs.tree.setCheckedKeys(ids)
                })

            }
        },
        mounted() {
            this.loadTagsData();
        }
    };
</script>

<style lang="less" scoped>
    .tag-box {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .tag-list {
            width: 48%;
            border: 1px solid rgb(233, 233, 233);
            border-radius: 5px;
            padding: 10px;
            height: 400px;
            overflow-x: hidden;
            overflow-y: auto;
            margin-right: 10px;

            .tag-list-header {
                padding-bottom: 5px;
                border-bottom: 1px solid rgb(233, 233, 233);
            }

            .tag-list-content {
                padding: 10px 0px;
                .custom-tree-node{
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    i{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 14px;
                        margin-right: 8px;
                    }
                    .arsenalfolder-open-fill{
                        font-size: 18px;
                    }

                }
            }
        }

        .tag-selected {
            width: 49%;
            border: 1px solid rgb(233, 233, 233);
            border-radius: 5px;
            padding: 10px;
            height: 400px;
            overflow-x: hidden;
            overflow-y: auto;

            .tag-selected-header {
                padding-bottom: 5px;
                border-bottom: 1px solid rgb(233, 233, 233);
            }

            .tag-selected-content {
                padding: 10px 0px;
            }

            .checkTags {
                display: flex;
                justify-content: space-between;
                padding: 6px 0;
                align-items: center;

                .tagName {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    i{
                        font-size: 14px;
                    }
                }

                .el-icon-close {
                    cursor: pointer;
                    color: red;
                }
            }
        }

        .buttonCheck {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: 0 10px;

            .el-button {
                margin: 20px 0;
            }
        }
    }
</style>